import React from "react";

export const BackgroundEffects: React.FC = () => {
  return (
    <>
      {/* Background Grid */}
      <div
        className="fixed inset-0 opacity-35 pointer-events-none z-[-2]"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
            linear-gradient(to right, rgba(255, 255, 255, 0.02) 1px, transparent 1px)`,
          backgroundSize: "120px 120px",
        }}
      />

      {/* Background Pulse */}
      <div
        className="fixed inset-0 opacity-75 pointer-events-none z-[-3] mix-blend-screen"
        style={{
          background: `radial-gradient(circle at 20% 10%, rgba(0, 212, 255, 0.2) 0, transparent 50%),
            radial-gradient(circle at 90% 70%, rgba(139, 92, 246, 0.2) 0, transparent 55%)`,
        }}
      />

      {/* Floating Particles */}
      <div
        className="fixed w-9 h-9 rounded-lg bg-gradient-to-br from-cyber-blue to-blockchain-purple opacity-8 blur-sm pointer-events-none z-[-1] animate-float"
        style={{ top: "12%", left: "8%" }}
      />
      <div
        className="fixed w-9 h-9 rounded-lg bg-gradient-to-br from-cyber-blue to-blockchain-purple opacity-8 blur-sm pointer-events-none z-[-1] animate-float"
        style={{ top: "70%", left: "18%", animationDelay: "4s" }}
      />
      <div
        className="fixed w-9 h-9 rounded-lg bg-gradient-to-br from-cyber-blue to-blockchain-purple opacity-8 blur-sm pointer-events-none z-[-1] animate-float"
        style={{ top: "25%", left: "80%", animationDelay: "8s" }}
      />
      <div
        className="fixed w-9 h-9 rounded-lg bg-gradient-to-br from-cyber-blue to-blockchain-purple opacity-8 blur-sm pointer-events-none z-[-1] animate-float"
        style={{ top: "82%", left: "76%", animationDelay: "12s" }}
      />
    </>
  );
};
